import { render, staticRenderFns } from "./42_mv_metodos_valoracion.vue?vue&type=template&id=70e5ed4e&scoped=true&"
import script from "./42_mv_metodos_valoracion.vue?vue&type=script&lang=js&"
export * from "./42_mv_metodos_valoracion.vue?vue&type=script&lang=js&"
import style0 from "./42_mv_metodos_valoracion.vue?vue&type=style&index=0&id=70e5ed4e&scoped=true&lang=css&"
import style1 from "./42_mv_metodos_valoracion.vue?vue&type=style&index=1&id=70e5ed4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e5ed4e",
  null
  
)

export default component.exports